import { render, staticRenderFns } from "./DialogTaxConfig.vue?vue&type=template&id=4402a6ca&"
import script from "./DialogTaxConfig.vue?vue&type=script&lang=js&"
export * from "./DialogTaxConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4402a6ca')) {
      api.createRecord('4402a6ca', component.options)
    } else {
      api.reload('4402a6ca', component.options)
    }
    module.hot.accept("./DialogTaxConfig.vue?vue&type=template&id=4402a6ca&", function () {
      api.rerender('4402a6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Products/DialogTaxConfig.vue"
export default component.exports